import { toast } from "react-toastify";
import { onAddEmployee, onGetOrgemployees } from "../services/employee";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { useStateSetter } from "./statehooks/UseStateSettersHook";
import { useEffect, useState } from "react";
import { onGetOrgContracts } from "../services/contract";

export default () => {
  const { setLoading } = useStateSetter();
  const [Contracts, setContracts] = useState<any[]>([]);
  const { SelectedOrg, config } = useStateGetter();

  const getOrgContracts = async () => {
    setLoading(true);
    try {
      var res = await onGetOrgContracts(SelectedOrg.id, config);
      setContracts(res.data);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.log(e);
      toast.error(e);
    }
  };

 const refresh= async ()=>{
 await getOrgContracts()
 }
  useEffect(()=>{

    getOrgContracts()

  },[])
  return { Contracts ,refresh};
};
